<div class="flex h-screen bg-gray-50">
    <!-- Sidebar for Desktop (hidden on mobile) -->
    <div class="relative hidden sm:block">
        <div class="w-16 transition-all duration-300 ease-in-out bg-black text-white flex flex-col shadow-2xl h-full"
            [class.hover:w-64]="!isLocked()" [class.group]="!isLocked()">
            <!-- Header -->
            <div class="p-4 border-b border-gray-800">
                <div class="flex items-center space-x-3">
                    <div class="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                        <img class="w-6 h-4" [src]="logoUrl" alt="NIKE Logo">
                    </div>
                    <div class="transition-opacity duration-300 whitespace-nowrap" [class.opacity-0]="true"
                        [class.group-hover:opacity-100]="!isLocked()">
                        <h1 class="text-lg font-bold">NIKE</h1>
                        <p class="text-xs text-gray-400">Tracker</p>
                    </div>
                </div>
            </div>

            <!-- Navigation Menu -->
            <nav class="flex-1 py-4 overflow-hidden">
                <div class="space-y-2">
                    @for (item of navItems(); track item.name) {
                    <div class="relative">
                        <a [routerLink]="item.enabled ? item.link : null"
                            [routerLinkActive]="['bg-gray-800', 'text-white']"
                            class="flex items-center px-4 py-3 text-sm font-medium mx-2 rounded-lg transition-all"
                            [class.text-gray-300]="item.enabled" [class.hover:bg-gray-800]="item.enabled"
                            [class.hover:text-white]="item.enabled" [class.text-gray-500]="!item.enabled"
                            [class.opacity-50]="!item.enabled" [class.cursor-not-allowed]="!item.enabled"
                            [class.pointer-events-none]="!item.enabled">
                            <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    [attr.d]="item.iconPath"></path>
                            </svg>
                            <span class="ml-3 transition-opacity duration-300 whitespace-nowrap"
                                [class.opacity-0]="true" [class.group-hover:opacity-100]="!isLocked()">{{ item.name
                                }}</span>
                            @if (!item.enabled) {
                            <span
                                class="ml-auto text-xs bg-gray-600 text-gray-300 px-2 py-1 rounded transition-opacity duration-300 whitespace-nowrap"
                                [class.opacity-0]="true" [class.group-hover:opacity-100]="!isLocked()">Disabled</span>
                            }
                        </a>
                    </div>
                    }
                    <div class="mx-4 my-4 border-t border-gray-800"></div>
                    <div class="relative">
                        <button (click)="openSettings()"
                            class="w-full flex items-center px-4 py-3 text-sm font-medium mx-2 rounded-lg transition-all text-gray-300 hover:bg-gray-800 hover:text-white">
                            <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z">
                                </path>
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                            </svg>
                            <span class="ml-3 transition-opacity duration-300 whitespace-nowrap"
                                [class.opacity-0]="true" [class.group-hover:opacity-100]="!isLocked()">{{
                                settingsItem().name }}</span>
                        </button>
                    </div>
                </div>
            </nav>

            <!-- User Section -->
            <div class="border-t border-gray-800 p-4">
                <div class="flex items-center space-x-3">
                    <div class="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center flex-shrink-0">
                        <span class="text-white font-semibold text-sm">M</span>
                    </div>
                    <div class="flex-1 transition-opacity duration-300 whitespace-nowrap" [class.opacity-0]="true"
                        [class.group-hover:opacity-100]="!isLocked()">
                        <p class="text-sm font-medium text-white">Maxim</p>
                        <p class="text-xs text-gray-400">Maxim User</p>
                    </div>
                    <button (click)="logout()" class="transition-opacity duration-300 text-gray-400 hover:text-white"
                        [class.opacity-0]="true" [class.group-hover:opacity-100]="!isLocked()">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1">
                            </path>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Bottom Navigation for Mobile (hidden on desktop) -->
    <div class="fixed bottom-0 left-0 right-0 bg-black text-white shadow-2xl block sm:hidden z-50">
        <nav class="flex justify-around items-center h-14">
            <!-- Show only the first 4 enabled navigation items for simplicity -->
            @for (item of navItems(); track item.name) {
            @if (item.enabled) {
            <a [routerLink]="item.link" [routerLinkActive]="['bg-gray-800', 'text-white']"
                class="flex flex-col items-center justify-center w-full py-2 rounded text-xs font-medium transition-all"
                [class.text-gray-300]="item.enabled" [class.hover:bg-gray-800]="item.enabled"
                [class.hover:text-white]="item.enabled">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="item.iconPath">
                    </path>
                </svg>
            </a>
            }
            }
            <!-- Settings Button -->
            <button (click)="openSettings()"
                class="flex flex-col items-center justify-center w-full py-2 text-xs font-medium text-gray-300 hover:bg-gray-800 hover:text-white">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z">
                    </path>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
            </button>
        </nav>
    </div>

    <!-- Settings Modal -->
    @if (showSettings()) {
    <div class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        (click)="closeSettings()">
        <div class="bg-white rounded-xl shadow-2xl w-full max-w-md mx-auto border border-gray-100 transform transition-all duration-200 scale-100 opacity-100"
            (click)="$event.stopPropagation()">
            <div class="flex items-center justify-between p-6 border-b border-gray-100">
                <div class="flex items-center gap-3">
                    <div class="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center">
                        <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z">
                            </path>
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                        </svg>
                    </div>
                    <h2 class="text-xl font-semibold text-gray-900">Settings</h2>
                </div>
                <button (click)="closeSettings()"
                    class="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-50 transition-all duration-150">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                        </path>
                    </svg>
                </button>
            </div>
            <div class="p-6">
                <div class="space-y-8">
                    <div class="group">
                        <div class="flex items-start justify-between gap-4">
                            <div class="flex-1 min-w-0">
                                <div class="flex items-center gap-2 mb-1">
                                    <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M4 6h16M4 10h16M4 14h16M4 18h16"></path>
                                    </svg>
                                    <h3 class="text-base font-medium text-gray-900">Lock Sidebar</h3>
                                </div>
                                <p class="text-sm text-gray-500 leading-relaxed">
                                    Keep the sidebar collapsed to maximize your workspace.
                                </p>
                            </div>
                            <div class="flex-shrink-0">
                                <label class="relative inline-flex items-center cursor-pointer">
                                    <input type="checkbox" [checked]="isLocked()" (change)="toggleLock()"
                                        class="sr-only peer">
                                    <div
                                        class="w-12 h-6 bg-gray-200 rounded-full peer transition-all duration-200 peer-checked:after:translate-x-6 after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all after:shadow-sm peer-checked:bg-gray-900 peer-focus:ring-4 peer-focus:ring-gray-200">
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="group pt-2 border-t border-gray-100">
                        <div class="flex items-start justify-between gap-4">
                            <div class="flex-1 min-w-0">
                                <div class="flex items-center gap-2 mb-1">
                                    <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                                        </path>
                                    </svg>
                                    <h3 class="text-base font-medium text-gray-900">Clear Cache</h3>
                                </div>
                                <p class="text-sm text-gray-500 leading-relaxed">
                                    Remove cached data and reload the application.
                                </p>
                            </div>
                            <div class="flex-shrink-0">
                                <button (click)="clearCache()"
                                    class="inline-flex items-center gap-2 px-4 py-2 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-800 active:bg-gray-950 transition-all duration-150 transform hover:scale-105 active:scale-95 shadow-sm">
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15">
                                        </path>
                                    </svg>
                                    Clear
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex justify-end p-6 border-t border-gray-50 bg-gray-50/50">
                <button (click)="closeSettings()"
                    class="inline-flex items-center px-6 py-2.5 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-800 active:bg-gray-950 transition-all duration-150 transform hover:scale-105 active:scale-95">
                    Done
                </button>
            </div>
        </div>
    </div>
    }
</div>